export default __webpack_public_path__ + "images/OS.cc03b13.png";